export default {
  cart: [],
  deliveryAddress: null,
  deliveryType: null,
  user: null
}
